import { useLocalStorage } from 'usehooks-ts'

import { useQueryClient } from '@tanstack/react-query'

import { QueryKeys } from './react-query'
import useCartData from './use-cart-data'

import { CartViewModel } from '../../types/api'

export const useAppCart = () => {
    const { isLoading, isAuditing, cart: apiCart } = useCartData()
    const [cartInStorage, setCartInStorage] = useLocalStorage<CartViewModel | undefined>('KHNM_CART', apiCart)
    const queryClient = useQueryClient()

    const updateCart = (newCart: CartViewModel) => {
        queryClient.setQueryData(QueryKeys.Cart.MyCart, newCart)
        queryClient.setQueryData(QueryKeys.Cart.CartCount, newCart.sumOfQty)

        setCartInStorage(newCart)
    }

    return { cart: apiCart, updateCart, isAuditing, isLoading, cartInStorage }
}
